module.exports = 'unicred-clube.api.hallo.app';
